export default __webpack_public_path__ + "1e4b6db506cac1a228ad65410960c0f5.svg";